import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { CurrencyModel } from "./currencies.model";

@Injectable()
export class CurrenciesService {

	constructor(private http: HttpClient) { }

	getAll(): Promise<CurrencyModel[]> {
		return this.http.get<CurrencyModel[]>(`${environment.apiUrl}/Currencies/All`).toPromise();
	}
}
